export default {"src":"/_next/static/media/fietsenstalling.9e12a867.svg","height":16,"width":23,"blurWidth":0,"blurHeight":0};